import { FormikHelpers } from "formik";
import PlaceForm from "./PlaceForm";
import { useGetPlace } from "./api/getPlace";
import { useEditPlace } from "./api/editPlace";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditPlace = ({handleCloseModal, placeId}: EditPlaceProps)  => {
  const getPlaceQuery = useGetPlace({placeId: placeId})
  const editPlaceMutation = useEditPlace({data: {}, placeId});

  const initialValues: IEditPlaceForm = {
    description: getPlaceQuery.data?.description,
    deleted: getPlaceQuery.data?.deleted,
    name: getPlaceQuery.data?.name,
    address: getPlaceQuery.data?.address,
    area_id: getPlaceQuery.data ? getPlaceQuery.data.area_id.toString() : "",
    city_id: getPlaceQuery.data ? getPlaceQuery.data.city_id.toString() : "",
    zip: getPlaceQuery.data?.zip,
    address_num: getPlaceQuery.data?.address_num,
    is_emporiki: getPlaceQuery.data?.is_emporiki,
    is_citi: getPlaceQuery.data?.is_citi,
  };

  const handleSubmit = async (values: IEditPlaceForm, { setSubmitting }: FormikHelpers<IEditPlaceForm>): Promise<void> => {
    try {
      await editPlaceMutation.mutateAsync({
        data: values,
        placeId: placeId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getPlaceQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getPlaceQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Τοποθεσίας.</div>
    )
  }

  return (
    <>
      {!getPlaceQuery.isLoading && getPlaceQuery.data &&
        <PlaceForm initialValues={initialValues} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditPlaceProps {
  placeId: number;
  handleCloseModal: () => void;
}

export default EditPlace;